import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33.9 26.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m33.9 0-1.6 8.8c-.9 5-2 7.9-8.4 7.9H18c-14.3.1-18 9.4-18 9.4.7-4.4 1.9-11.7 2.5-15.2C3.6 4.7 7.9 0 17.3 0h16.6Z",
      style: {"fill":"#2cb9f1"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "7L-logo"}) } }